import { Component, OnInit , ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { EnquiryentryService } from "../shared/enquiryentry.service";

@Component({
  selector: 'app-enquirylist',
  templateUrl: './enquirylist.component.html',
  styleUrls: ['./enquirylist.component.css']
})
export class EnquirylistComponent implements OnInit {

  displayedColumns: string[] = ['EnquiryNo', 'Enquiry Date', 'Name', 'Address','MobileNo',
  'Members Visited','Expected Members','Interested Members','Is Preliminary','Prel. Meeting Date', 'New'];
  // 'No. of Members',

  EnquiryEntryList$ =[''];

  dataSource = new MatTableDataSource<any>();
 @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(private router: Router,public enquiryEntryService:EnquiryentryService) { }

  ngOnInit() {
    this.getEnquiryEntryList();
    this.dataSource.paginator = this.paginator;
  }

  public AddNewEnquiry()
  {
    this.router.navigate(['/enquiry']);
  }

  getEnquiryEntryList(){
    this.enquiryEntryService.FetchEnquiryEntryList().subscribe(data =>{
      // this.EnquiryEntryList$=data;
      this.dataSource.data =data;
    })
  }

  EditCustomers(enquiryId : any){
    this.router.navigate(['/enquiry',enquiryId.Id]);
  }

}
